<template lang="html">

  <div>
    <div class="modal modal-left small fade"
         id="notif-modal"
         tabindex="-1"
         role="dialog"
         aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Notifications
              <span class="position-absolute ms-3 translate-middle badge rounded-pill bg-danger">
                        {{ unread.length }}
                    </span>
            </h5>
            <button type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="row gx-2" id="sortAndFilter">

              <div class="col-4 d-flex">
                <div class="form-check mb-2">
                  <input type="checkbox"
                         style="border-width:0px"
                         class="form-check-input filter bg-warning rounded-xl"
                         id="category1"
                         v-model="filters.message"/>
                  <label class="form-check-label cursor-pointer color-warning"
                         for="category1">Message </label>
                </div>

              </div>
              <div class="col-4 d-flex">
                <div class="form-check mb-2">
                  <input type="checkbox"
                         style="border-width:0px"
                         class="form-check-input filter bg-info rounded-xl"
                         id="category2"
                         v-model="filters.modification"/>
                  <label class="form-check-label cursor-pointer color-info"
                         for="category2">Modification</label>
                </div>
              </div>
              <div class="col-4 d-flex justify-content-end custom-sort">
                <div class="cursor-pointer my-sort d-flex"
                     @click="toggleSortDirection">
                  Date
                  <i class="bi" :class="sortDirection === 'asc' ? 'bi-arrow-up' : 'bi-arrow-down'"></i>
                </div>
              </div>
              <span v-if="notifications.length==0">
                        <div class="dummy"
                             style="padding:5px;font-size:14px;">Aucune notification</div>
                    </span>
              <div class="">
                <div class="scroll-by-count"
                     :data-count="filteredAndSortedNotifications.length"
                     data-childSelector=".scroll-child">
                  <div class="my-card h-auto m-0 p-0 mb-2 mr-2"
                       :class="getNotifClass(item.title)"
                       v-for="item in filteredAndSortedNotifications">
                    <a :class="{undone:!item.done}"
                       href="#"
                       class="row g-0 sh-7 justify-content-center d-flex align-items-center">
                      <div @click="clicked(item)"
                           class="col-auto h-100 custom-notification-block"
                           :style="{'background-image': 'url('+backend_root+item.image+')', 'width':'60px'}">
                      </div>
                      <div class="col h-100 ">
                        <div
                            class="card-body d-flex flex-row pt-0 pb-0 ps-3 pe-3 h-100 align-items-center justify-content-between">
                          <div @click="clicked(item)"
                               class="d-flex flex-column">
                            <div>{{ item.title }}</div>
                            <!--<div class="text-alternate small">{{item.message}}</div>-->
                            <div class="text-muted date"
                                 :title="item.created_on">
                              {{ item.created_on|human_date }}
                            </div>
                          </div>
                          <div class="d-flex">

                            <button type="button"
                                    @click="delete_notif(item)"
                                    class="btn btn-outline-primary btn-sm btn-icon btn-icon-only ms-1 ms-auto">
                              <i class="bi-trash"></i>
                            </button>
                            <button v-if="item.done"
                                    type="button"
                                    @click="toggle_read(item)"
                                    title='Marquer comme non lu'
                                    class="btn btn-outline-primary btn-sm btn-icon btn-icon-only ms-1 ms-1">
                              <i class="bi bi-eye-slash-fill"></i>
                            </button>
                            <button v-else
                                    type="button"
                                    @click="toggle_read(item)"
                                    title='Marquer comme lu'
                                    class="btn btn-outline-primary btn-sm btn-icon btn-icon-only ms-1 ms-1">
                              <i class="bi bi-eye"></i>
                            </button>

                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer border-0">
            <div class="btn-group"
                 role="group">
              <button class="btn btn-outline-primary"
                      type="button"
                      data-bs-dismiss="modal"
                      aria-label="Close">Fermer
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import NOTIFICATION_TOGGLE_DONE from '@/gql/mutations/notificationToggleDone.graphql';
import NOTIFICATION_DELETE_READ from '@/gql/mutations/notificationDeleteRead.graphql';
import NOTIFICATION_DELETE from '@/gql/mutations/notificationDelete.graphql';
import NOTIFICATION_MARK_DONE from '@/gql/mutations/notificationMarkDone.graphql';
import NOTIFICATION_SET from '@/gql/queries/notificationSet.graphql';
import { gqlMutation, gqlQuery } from '@/gqlClient.js';
import settings from '@/settings.coffee';

const notifTypes = {
  "Nouveau commentaire": "message",
  "Validation de la réponse": "modification",
  "Text de réponse": "modification",
  "Signalement demandé": "modification",
  "Réponse demandée": "modification",
  "L'établissement prend": "modification",
  "L'établissement ne veux pas": "modification"
};

export default {
  name: 'Notification',
  data() {
    return {
      opened: false,
      notifications: [],
      avatar: this.$store.state.profile.data.avatar,
      backend_root: settings.backendUrl,
      sortDirection: 'desc',
      filters: {
        message: true,
        modification: true
      }
    };
  },
  computed: {
    unread() {
      return this.notifications.filter(a => !a.done);
    },
    filteredAndSortedNotifications() {
      const filtered = this.notifications.filter(item => {
        const notiftype = this.getNotificationType(item.title);
        return (this.filters.message && notiftype === 'message') ||
            (this.filters.modification && notiftype === 'modification');
      });
      filtered.sort((a, b) => {
        const dateA = new Date(a.created_on);
        const dateB = new Date(b.created_on);
        if (this.sortDirection === 'asc') {
          return dateA - dateB;
        } else {
          return dateB - dateA;
        }
      });
      return filtered;
    }
  },
  watch: {
    'filters.message'(newVal) {
      if (!newVal && !this.filters.modification) {
        this.filters.modification = true;
      }
    },
    'filters.modification'(newVal) {
      if (!newVal && !this.filters.message) {
        this.filters.message = true;
      }
    }
  },
  methods: {
    async fetch_notifications() {
      const res = await gqlQuery(NOTIFICATION_SET, { consultant_uid: this.$store.state.profile.data.uid });
      this.notifications = res.body.data.notification_set || [];
    },
    toggleSortDirection() {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    },
    getNotificationType(title) {
      for (const key in notifTypes) {
        if (title.startsWith(key)) {
          return notifTypes[key];
        }
      }
      return 'message';
    },
    getNotifClass(title) {
      const notiftype = this.getNotificationType(title);
      if (notiftype === 'modification') {
        return 'custom-border-info';
      }
      return 'custom-border-warning';
    },
    toggle_read(notif) {
      gqlMutation(NOTIFICATION_TOGGLE_DONE, { uid: notif.uid }).then(() => {
        const index = this.notifications.findIndex(n => n.uid === notif.uid);
        if (index !== -1) {
          this.$set(this.notifications[index], 'done', !notif.done);
        }
        this.$emit('notifications-updated');
      });
    },
    delete_read() {
      gqlMutation(NOTIFICATION_DELETE_READ, {});
    },
    delete_notif(item) {
      gqlMutation(NOTIFICATION_DELETE, { uid: item.uid }).then(() => {
        this.fetch_notifications();
        this.$emit('notifications-updated');
      });
    },
    clicked(item) {
      const modalEl = document.getElementById('notif-modal');
      const modal = bootstrap.Modal.getInstance(modalEl);
      modal.hide();
      gqlMutation(NOTIFICATION_MARK_DONE, { uid: item.uid }).then(() => {
        const index = this.notifications.findIndex(n => n.uid === item.uid);
        if (index !== -1) {
          this.$set(this.notifications[index], 'done', true);
        }
        this.$emit('notifications-updated');
      });
      this.$router.push({
        name: "flow_detail",
        params: {'uid': item.object_id}
      });
    },
    closeListener(e) {
      if (!this.$el.contains(e.target)) {
        this.opened = false;
      }
    }
  },
  async mounted() {
    await this.fetch_notifications();
    document.addEventListener('click', this.closeListener, true);
    this.$djangows['onnotification'](async () => {
      await this.fetch_notifications();
      this.$emit('notifications-updated');
    });
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeListener, true);
  }
};
</script>

<style lang="scss" scoped>
.my-sort i {
  margin-left: 5px;
}

.has-pointer {
  cursor: pointer;
}

.dropdown-item.undone {
  border-right: 5px solid rgb(216, 155, 23) !important;
}

.dropdown-divider {
  margin: 0;
}

.dropdown-content {
  max-height: 400px;
  overflow-y: scroll;
  width: 100%;
}

.dummy {
  overflow: hidden;
}

.dropdown-header {
  height: 40px;
  width: 100%;
  background-color: white;
  border-top: 1px solid #dbdbdb;
  border-right: 1px solid #dbdbdb;
  border-left: 1px solid #dbdbdb;
  padding: 5px;
}

#notif-modal {
  z-index: 100000;
}

.modal-content {
  width: 120%;
}

.card {
  overflow: hidden;
  scrollbar-width: none;
}

.custom-border-warning {
  border-right: 3px solid var(--warning) !important;
}

.custom-border-info {
  border-right: 3px solid var(--info) !important;
}

.my-card {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03) !important;
  background: var(--foreground);
  border-top-left-radius: var(--border-radius-lg);
  border-bottom-left-radius: var(--border-radius-lg);
  border: initial;
  overflow: hidden;
}

.custom-notification-block {
  background-position: left;
  background-size: cover;
}
</style>
